import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Dropdown, Spinner } from 'react-bootstrap';
import { Bell, MessageSquare, RefreshCw } from 'react-feather';
import { toast } from 'react-toastify';
import { ChatState } from '../utils/Context/ChatProvider';
import { initials } from '../utils/chat/inboxPresentation';
import './ChatNotifications.css';

export default function ChatNotifications() {
  const { notification = [], unreadCount = 0, inboxError, refreshInbox, setSelectedChat } = ChatState();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [opening, setOpening] = useState(null);
  const [refreshing, setRefreshing] = useState(false);
  const openConversation = async (item) => {
    if (opening !== null) return;
    setOpening(item.chat_id);
    try {
      // Route intent survives mounting Contacts; never depend on a stale cached
      // list or let the previous chat be acknowledged while resolving this one.
      setSelectedChat(undefined);
      setOpen(false);
      history.push(`/contact-customers?chat=${encodeURIComponent(item.chat_id)}`);
      // Only the existing message-read acknowledgement clears the badge.
    } catch (_) {
      toast.error('Could not open this conversation. Please try again.');
    } finally { setOpening(null); }
  };
  const retry = async () => {
    setRefreshing(true);
    try { await refreshInbox(); } finally { setRefreshing(false); }
  };
  const label = inboxError
    ? 'Chat notifications unavailable' + (unreadCount ? ', ' + unreadCount + ' unread messages last checked' : '')
    : unreadCount + ' unread messages';
  return <Dropdown alignRight show={open} onToggle={setOpen} className={'admin-chat-notifications' + (unreadCount ? ' is-unread' : '')}>
    <Dropdown.Toggle id="admin-chat-notifications" className="nav-link count-indicator p-0 toggle-arrow-hide bg-transparent"
      aria-label={label} title="Chat messages">
      <Bell className="admin-chat-bell" size={23} aria-hidden="true" />
      {unreadCount > 0 && <span className="count bg-success" aria-hidden="true">{unreadCount > 99 ? '99+' : unreadCount}</span>}
      {inboxError && !unreadCount && <span className="admin-chat-notifications__warning" aria-hidden="true">!</span>}
    </Dropdown.Toggle>
    <span className="sr-only" role="status" aria-live="polite">{inboxError ? 'Chat notifications temporarily unavailable' : unreadCount + ' unread chat messages'}</span>
    <Dropdown.Menu className="navbar-dropdown admin-chat-notifications__menu">
      <div className="admin-chat-notifications__heading"><strong>Messages</strong><span>{unreadCount} unread</span></div>
      {inboxError && <div className="admin-chat-notifications__error" role="alert">
        <span>Could not refresh messages. Showing the last update.</span>
        <button type="button" className="btn btn-outline-primary btn-sm" onClick={retry} disabled={refreshing}><RefreshCw size={14} aria-hidden="true" /> {refreshing ? 'Refreshing…' : 'Retry'}</button>
      </div>}
      <div className="admin-chat-notifications__list">
        {!notification.length && !inboxError && <p className="admin-chat-notifications__empty"><MessageSquare size={20} aria-hidden="true" />You are all caught up.</p>}
        {notification.map((item) => <Dropdown.Item as="button" key={item.chat_id}
          className="admin-chat-notifications__item" disabled={opening !== null} onClick={(event) => { event.preventDefault(); openConversation(item); }}>
          <span className="admin-chat-notifications__avatar" aria-hidden="true">{initials(item.name)}</span>
          <span className="admin-chat-notifications__copy"><strong>{item.name}</strong><span>{item.content}</span></span>
          {opening === item.chat_id ? <Spinner animation="border" size="sm" /> : <span className="admin-chat-notifications__count">{item.unread_count}</span>}
        </Dropdown.Item>)}
      </div>
      <Dropdown.Item as="button" className="admin-chat-notifications__all" onClick={() => { setOpen(false); history.push('/contact-customers'); }}>View all conversations</Dropdown.Item>
    </Dropdown.Menu>
  </Dropdown>;
}
